(ns common.schema.entities.survey-cycle.schema
  (:require
   [common.schema.entities.rotation-period.option-source :as rotation-period-options]
   [common.schema.entities.survey-cycle.options :as options]
   [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    (su/text-simple-field :survey-cycle/cycle-label
                          "Label"
                          {:authorization            su/access-user-user
                           :default-field-visibility :in-use-disabled
                           ;; See the note on the rotation period label - this is
                           ;; the entity's display name.
                           :mandatory-config         :mandatory/always})
    (su/single-ref-field :survey-cycle/rotation-period
                         "Rotation period"
                         [:entity.type/rotation-period]
                         {:authorization            su/access-user-user
                          :default-field-visibility :in-use-disabled
                          ;; Mandatory because a cycle without a rotation period
                          ;; resolves no template: it reaches a mass send and
                          ;; reports "No rotation period" for every profile,
                          ;; having looked perfectly well configured until then.
                          :mandatory-config         :mandatory/always
                          ;; No explicit :editor-type. The default
                          ;; :editor.type/select already routes a ref-single to
                          ;; open-search-select/render-async-select-single, which
                          ;; queries the index and applies os-filter-terms-fn.
                          ;; :editor.type/search has no defmethod in the legacy
                          ;; basic_components editor path this dialog uses, and
                          ;; renders "No 'editor' for ':editor.type/search'".
                          :option-filter-fn         rotation-period-options/for-containing-survey-type
                          :os-filter-terms-fn       rotation-period-options/survey-type-filter-terms})
    (su/datetime-field :survey-cycle/timestamp-period-start
                       "Period start"
                       {:authorization            su/access-user-user
                        :default-field-visibility :in-use-disabled})
    (su/datetime-field :survey-cycle/timestamp-period-end
                       "Period end"
                       {:authorization            su/access-user-user
                        :default-field-visibility :in-use-disabled})
    (su/datetime-field :survey-cycle/cycle-default-deadline
                       "Default deadline"
                       {:authorization            su/access-user-user
                        :default-field-visibility :in-use-disabled})
    (su/keyword-field :survey-cycle/cycle-status
                      "Status"
                      options/cycle-status-options
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})
    (su/multi-ref-field :survey-cycle/notification-recipients
                        "Notification recipients"
                        [:entity.type/account :entity.type/team]
                        {:authorization            su/access-user-user
                         :default-field-visibility :in-use-disabled})
    (su/boolean-field :survey-cycle/automatic-reminders?
                      "Automatic reminders?"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})
    (su/multi-ref-field :survey-cycle/survey-batches
                        "Survey batches"
                        [:entity.type/survey-batch]
                        {:authorization            su/access-user-user
                         :editor-type              :editor.type/none
                         :grid-type                :editor.type/none
                         :filter-type              :filter.type/none
                         :default-field-visibility :in-use-disabled}))))
